/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OnHoldDto } from './onHoldDto';
import { ActivityDto } from './activityDto';

export interface WorkOrderDetailsDto {
  id?: string;
  workOrderNumber?: string;
  title?: string;
  workCenterId?: string;
  projectId?: string;
  statusName?: string;
  siteNo?: string;
  division?: WorkOrderDetailsDto.DivisionEnum;
  startDate?: string;
  endDate?: string;
  status?: WorkOrderDetailsDto.StatusEnum;
  estimatedHours?: number;
  actualHours?: number;
  actualMinutesUsed?: number;
  progress?: number;
  weeksProgress?: number;
  released?: boolean;
  releasedToAll?: boolean;
  isAssigned?: boolean;
  closed?: boolean;
  onHold?: Array<OnHoldDto>;
  isFavourite?: boolean;
  activity?: ActivityDto;
  commentCount?: number;
  weightLineSentCount?: number;
  weightLineTotalCount?: number;
  description?: string;
  precedingWorkOrderId?: string;
  precedingWorkOrderExists?: boolean;
  precedingWorkOrderNumber?: string;
  precedingWorkOrderProgress?: number;
  succeedingWorkOrderId?: string;
  succeedingWorkOrderExists?: boolean;
  succeedingWorkOrderNumber?: string;
  succeedingWorkOrderProgress?: number;
  wbs?: string;
  weeklyProgressHours?: number;
  showWeeklyProgress?: boolean;
  hoursRemaining?: number;
  showObjectHierarchy?: boolean;
  showOperations?: boolean;
  showObjectWorkLines?: boolean;
}
export namespace WorkOrderDetailsDto {
  export const DivisionEnum = {
    Sls: 'SLS',
    Fabrication: 'FABRICATION',
    Offshore: 'OFFSHORE',
  } as const;
  export type DivisionEnum = (typeof DivisionEnum)[keyof typeof DivisionEnum];
  export const StatusEnum = {
    Unreleased: 'UNRELEASED',
    Released: 'RELEASED',
    Assigned: 'ASSIGNED',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
